import type { ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';
import type {
  ICartCalculateResponse,
  IConnectivityDetails,
  IProposalCartItem,
  NegotiationType,
} from '@/types/commercial/cart';

export interface AddCartItemPayload {
  negotiationType: NegotiationType;
  quantity?: number;
  discountPercent?: number;
  connectivityDiscountPercent?: number;
  connectivityDetails?: IConnectivityDetails;
  productId?: string;
  serviceId?: string;
  accessoryId?: string;
  connectivityId?: string;
}

export interface UpdateCartItemPayload {
  negotiationType?: NegotiationType;
  quantity?: number;
  discountPercent?: number;
  connectivityDiscountPercent?: number;
  unitPriceCashInCents?: number;
  unitPriceInstallmentInCents?: number;
  unitPriceMonthlyInCents?: number;
  unitPriceYearlyInCents?: number;
  unitPriceFixedInCents?: number;
}

export const cartItemApi = {
  findMany: async (proposalId: string): Promise<IProposalCartItem[]> => {
    const { data } = await api.get<ApiResponse<IProposalCartItem[]>>(
      `/commercial/proposals/${proposalId}/cart`,
    );
    return data.data;
  },

  addOne: async (proposalId: string, payload: AddCartItemPayload): Promise<IProposalCartItem> => {
    const { data } = await api.post<ApiResponse<IProposalCartItem>>(
      `/commercial/proposals/${proposalId}/cart`,
      payload,
    );
    return data.data;
  },

  updateOne: async (
    proposalId: string,
    itemId: string,
    payload: UpdateCartItemPayload,
  ): Promise<IProposalCartItem> => {
    const { data } = await api.patch<ApiResponse<IProposalCartItem>>(
      `/commercial/proposals/${proposalId}/cart/${itemId}`,
      payload,
    );
    return data.data;
  },

  removeOne: async (proposalId: string, itemId: string): Promise<void> => {
    await api.delete(`/commercial/proposals/${proposalId}/cart/${itemId}`);
  },

  calculate: async (proposalId: string): Promise<ICartCalculateResponse> => {
    const { data } = await api.get<ApiResponse<ICartCalculateResponse>>(
      `/commercial/proposals/${proposalId}/cart/calculate`,
    );
    return data.data;
  },
};
